<script>
import { mapGetters } from 'vuex';
import SwitchLayout from './SwitchLayout.vue';
import { frontendURL } from 'dashboard/helper/URLHelper';

export default {
  components: {
    SwitchLayout,
  },
  directives: {
    focus: {
      inserted(el) {
        el.focus();
      },
    },
  },
  computed: {
    ...mapGetters({
      accountId: 'getCurrentAccountId',
    }),
    searchUrl() {
      return frontendURL(`accounts/${this.accountId}/search`);
    },
  },
  props: {
    isOnExpandedLayout: {
      type: Boolean,
      required: true,
    },
  },
};
</script>

<template>
  <div class="relative">
    <div
      class="flex px-4 pb-1 flex-row gap-1 pt-2.5 border-b border-transparent"
    >
      <div class="bg-icon">
        <woot-sidemenu-icon
          size="tiny"
          class="sidemenu-icon-button"
        />
      </div>
      <router-link
        :to="searchUrl"
        class="search-link bg-search flex-1 items-center gap-1 text-left h-6 rtl:mr-3 rtl:text-right rounded-md px-2 py-0 bg-slate-25 dark:bg-slate-800 inline-flex"
      >
        <div class="flex bg-icon-search">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="17"
            height="17"
            viewBox="0 0 17 17"
            fill="none"
          >
            <path
              d="M16.6593 15.1196L11.5411 9.99876C12.4523 8.69746 12.8432 7.10149 12.6367 5.5258C12.4301 3.95011 11.6411 2.50915 10.4253 1.4873C9.20955 0.465439 7.65534 -0.0630884 6.0694 0.00601269C4.48346 0.0751138 2.98099 0.736824 1.8585 1.86056C0.736008 2.9843 0.0750306 4.48843 0.00600603 6.07613C-0.0630185 7.66383 0.464924 9.21976 1.48565 10.4369C2.50637 11.654 3.94573 12.4439 5.51968 12.6507C7.09363 12.8574 8.68783 12.4661 9.98768 11.5539L15.106 16.6747C15.314 16.883 15.5962 17 15.8905 17C16.1848 17 16.467 16.883 16.675 16.6747C16.8831 16.4664 17 16.1839 17 15.8893C17 15.5947 16.8831 15.3122 16.675 15.1039L16.6593 15.1196ZM9.27847 9.28875C8.6982 9.86941 7.95899 10.2648 7.15428 10.4249C6.34958 10.585 5.51553 10.5026 4.75758 10.1882C3.99962 9.87384 3.35181 9.34151 2.89603 8.65856C2.44026 7.97561 2.19699 7.1727 2.19699 6.35135C2.19699 5.53 2.44026 4.72709 2.89603 4.04414C3.35181 3.36119 3.99962 2.82886 4.75758 2.51446C5.51553 2.20006 6.34958 2.11771 7.15428 2.27781C7.95899 2.43792 8.6982 2.83329 9.27847 3.41394C10.0546 4.1941 10.4903 5.2503 10.4903 6.35135C10.4903 7.4524 10.0546 8.5086 9.27847 9.28875Z"
              fill="#3CBEB6"
            />
          </svg>
        </div>
        <p
          class="search--label text-label mb-0 overflow-hidden whitespace-nowrap text-ellipsis text-sm text-slate-800 dark:text-slate-200"
        >
          {{ $t('CONVERSATION.SEARCH_MESSAGES') }}
        </p>
      </router-link>
      <div class="bg-icon">
        <SwitchLayout
          :is-on-expanded-layout="isOnExpandedLayout"
          @toggle="$emit('toggleConversationLayout')"
        />
      </div>
    </div>
  </div>
</template>

<style lang="scss" scoped>
.search-link {
  &:hover {
    .search--icon,
    .search--label {
      @apply hover:text-[#3cbeb6] dark:hover:text-[#3cbeb6];
    }
  }
}
.bg-icon {
  background-color: #fff;
  width: 32px;
  height: 32px;
  flex-shrink: 0;
  border-radius: 5px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.sidemenu-icon-button {
  margin: 0 !important;
}

.bg-search {
  width: 277px;
  height: 33px;
  flex-shrink: 0;
  background-color: var(--BRANCO, #fff);
}

.text-label {
  color: #626679;
  font-family: Poppins;
  font-size: 11px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
  margin-left: 6px;
}

.bg-icon-search {
  width: 17px;
  height: 17px;
  flex-shrink: 0;
}
</style>
